/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import InputField from "@/components/Atoms/InputField";
import InputLabel from "@/components/Atoms/InputLabel";
import {useResponseId,useUrlType} from "@/components/hooks";
import {RootState} from "@/reducers/store";
import {useValidate} from "@/state/survey/formSlice";
import {BasicAnswerSave,useUpdateAnswersSubmit} from "@/state/survey/saveAnswerSlice";
import {Utility,Validate} from "@/utils";
import React,{useCallback,useEffect,useRef,useState} from "react";
import {useSelector} from "react-redux";
import poaAnswerDetails from "../../SurveyModel/poaQuestions/poaAnswerDetails";
import {IAnswers} from "../../SurveyModel/types/commonTypes";
import {INode} from "../../SurveyModel/types/nodeTypes";


const QuestionTextOnly = (props:any) => {
    const {node } = props;
    //const { currentPage} = useSelector((state:RootState) => state.patientSurvey);
    const { answersObj} = useSelector((state:RootState) => state.patientSurvey);
    const form = useSelector((state:RootState) => state.form);
    const updateAnswersDispatch = useUpdateAnswersSubmit();
    const {answerResponseId} = useResponseId();
    const validateInputField = useValidate();
    const {isPatient} = useUrlType()
    //const setCurrentNode = useSetCurrentNode();
    //const [inputValue ] = useState(form[node.name].value);
    const [rows, setRows] = useState<INode[]>([])
    const isInitialRun = useRef(true); 
  

    useEffect(()=>{
        if(isInitialRun.current && node ){
            isInitialRun.current = false
            const localRows = node.nodes 
            ? node.nodes // Safely cast to string
            : [];
                setRows([...rows, ...localRows]);
            
        }
    }, [node, answersObj]);

    function updateSubQuestionValue(subQuestionValues: IAnswers[], name: string, newValue: string ) {
        const index = subQuestionValues.findIndex(item => item.name === name);
        if (index !== -1) {
            // Update the value
            subQuestionValues[index].value = newValue;
        } else {
            console.log(`Element with name "${name}" not found.`);
        }
    }

    // Wrap handleChange with useCallback
    const handleChange = useCallback(
        (value: string, name: string) => {
          validateInputField(name, value, true);
         
          const subQuestionValues:  IAnswers[] = []
        if(!isPatient && answerResponseId) {
            const selectedNode = node.nodes.find((item: INode)=> item.name === name);
            const answers: BasicAnswerSave[] = poaAnswerDetails.generateQuestionAnswerSubmitFormat(form,selectedNode )
            updateAnswersDispatch(answers, answerResponseId);
        }  
        else {
            rows.forEach((field)=>{
                const value  = form[field.name]?.value as string ?? '';
                    const answer = {
                        name: field.name,
                        value: value
                    }
                    subQuestionValues.push(answer)    
                })
                updateSubQuestionValue(subQuestionValues, name, value )
                validateInputField(node.name, subQuestionValues, true);
        }
        if(node.validationDependants) {
            node.validationDependants.forEach((element : string)=> {
                validateInputField(element, form[element].value, true);
            });
        }
         
        },
        [validateInputField,form, node, rows, isPatient, updateAnswersDispatch]
      );


      


     const renderComponents = (rowElement:INode, index: number) => {
        const { state = {} } = form[rowElement.name];
        return (<React.Fragment key={index}>
        <div className= {`question-txt-only-block ${index != 1 ? 'first-element': ''} ${isPatient ? '': 'flex'}`}>
       <InputLabel type="subTitle" label={rowElement.subTitle ? rowElement.subTitle : "" } labelClasses="input-label title-style"></InputLabel> 
        <InputField form={form} isInValid = {Validate.isInvalid(state)}  propClasses={'single-line-text flex'}  type="text" value={form[rowElement.name].value}  name={rowElement.name} onChange={handleChange} />
        </div>
        </React.Fragment>)   
    };


    
    return (
        <div className={`user-input question-text-only-wrap 
        ${Utility.getClassForWidthPx(node)}  
         ${node.name}
        ${Utility.getClassForWidth(node)}  
        question-txt-only ${!isPatient ? 'poa-input': '' } `}>
            {node.title ? <InputLabel type="title" label={node.title} labelClasses="input-label title-style"></InputLabel> : '' }
            {node.subTitle ? <InputLabel type="subTitle" label={node.subTitle} labelClasses="input-label"></InputLabel> : ''}
            {rows.map((item:INode, index: number)=>renderComponents(item, index))}
        </div>
    )
}

export default QuestionTextOnly;
